export const ALLOW_MULTI_SELECT = ['allowMultiSelect'];
export const ALLOW_USER_INPUT = ['allowUserInput'];
export const QUICK_REPLIES = ['quickReplies'];